function validateDate(startDate, endDate, checkDate = Date.now()) {
  if (startDate > endDate) {
    return false;
  }
  if (startDate && !endDate) {
    return startDate < checkDate;
  }
  if (!startDate && endDate) {
    return checkDate < endDate;
  }
  if (startDate && endDate) {
    return startDate < checkDate && checkDate < endDate;
  }
  return false;
}

export default validateDate;
